import { render, staticRenderFns } from "./JoinProjectAsParticipant.vue?vue&type=template&id=4937e652&scoped=true&lang=pug&"
import script from "./JoinProjectAsParticipant.vue?vue&type=script&lang=js&"
export * from "./JoinProjectAsParticipant.vue?vue&type=script&lang=js&"
import style0 from "./JoinProjectAsParticipant.vue?vue&type=style&index=0&id=4937e652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4937e652",
  null
  
)

export default component.exports